export const SEARCH_LOAD_REQUEST = 'SEARCH_LOAD_REQUEST';
export const SEARCH_LOAD_SUCCESS = 'SEARCH_LOAD_SUCCESS';
export const SEARCH_LOAD_FAILURE = 'SEARCH_LOAD_FAILURE';
